import styled from 'styled-components';
import { FONTS } from '@app/src/ui';

export const Wrapper = styled.div`
  font-family: ${FONTS.OPEN_SANS};
  font-size: 13px;
  line-height: 16px;
  span {
    display: block;
    margin-bottom: 10px;
  }
`;

export const Link = styled.a`
  display: inline-block;
  cursor: pointer;
  &:not(:nth-child(2)) {
    margin-left: 8px;
  }
  &:nth-child(4) {
    margin-left: 8px;
    img {
      width: 73px;
    }
  }
`;

export const Patner = styled.img`
  width: 65px;
  height: 40px;
`;
